import { useRequest, useSetState } from 'ahooks'
import { useState } from 'react'
// import { useEffect } from 'react'

export default () => {
    const [state, setState] = useSetState({
        showExtendGuide: false,
        showExtendSTEP1: false
    })

    // 控制我的分销小站右侧的访客趋势图 是否展示提示信息 (迁移老功能)
    const [chartTooltipShow, setChartTooltipShow] = useState(false)

    return { supportState: state, setSupportState: setState, chartTooltipShow, setChartTooltipShow }
}
